import { type PropsWithChildren, useState, type FC } from 'react';
import classNames from 'classnames';

import ArrowIcon from 'app/icons/arrow-min.svg';

import style from './style.module.scss';

interface Props extends PropsWithChildren {
  title?: string;
  position: 'bottom' | 'top';
  tabIndex?: number;
  arrowSize?: 'small' | 'medium';
  defaultState?: 'opened' | 'closed';
}

const ExpandableBlock: FC<Props> = ({
  children,
  title,
  tabIndex,
  position,
  arrowSize = 'small',
  defaultState = 'opened'
}) => {
  const [expanded, setExpanded] = useState(defaultState === 'opened');
  return (
    <div className={style.expandableBlock}>
      {position === 'top' && expanded && <div>{children}</div>}
      <button
        className={classNames(style.expandableBlockHeader, { [style.withTitle]: !!title })}
        onClick={() => setExpanded(!expanded)}
        type="button"
        tabIndex={tabIndex}
      >
        {title && <div className={style.expandableBlockTitle}>{title}</div>}
        <ArrowIcon
          className={classNames(style.arrowIcon, style[arrowSize], {
            [style.arrowIconOpened]: expanded
          })}
        />
      </button>
      {position === 'bottom' && expanded && <div>{children}</div>}
    </div>
  );
};

ExpandableBlock.displayName = 'ExpandableBlock';

export default ExpandableBlock;
